// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3V9XZ","item":"PaymentsMobile_item__3Xyqm","label":"PaymentsMobile_label__2Yh-d","amount":"PaymentsMobile_amount__1nThV"};